import axios from 'axios';
import md5 from 'js-md5';
import { DateUtil } from './date';
import { AjaxMethod } from '@/utils/dataMap';
import Vue from 'vue';
import store from '@/store';
import * as types from '@/store/mutation-types';
import { apiBaseUrl } from './common';
import { MessageBox } from 'element-ui';
import { API_OBJECT } from '@/utils/burialLpointApi/index';
import { checkAccount, resetCookie } from './checkAccountChange';
import HotFresh from '@/utils/hotFresh/index.js';

const API_SECRET = '123456';
const TIMEOUT = 30000;
const ERROBJ = {
	netErr: {
		code: 10000010,
		message: '网络出问题了',
	},
	noLogin: {
		code: 401, // 为登录
		message: '未登录',
	},
	forbidden: {
		code: 403,
		message: '您没有该权限',
	},
	serviceErr: {
		code: 500,
		message: '服务器异常',
	},
	timeout: {
		code: 10000011, // 超时
		message: '请求超时',
		data: null,
	},
};

// 记录当前的cookie 和 每次请求的cookie对比 如果cokkie不符 证明用户在其他窗口重新登陆嘞账号 此时需要重置视角相关的本地数据
let setCookieUrl = ['/api/login/pre-login', '/api/official-account/pre-sms-login', '/api/official-account/login-conform'];
// 生成cookie
const createCustomCookie = () => {
	const _cookies = [{ key: 'token', value: CookiesTools.getToken() || '' }];
	const _cookiesText = _cookies.map(item => `${item.key}=${item.value}`).join('&');
	return _cookiesText;
};

let config = {
	timeout: TIMEOUT,
	withCredentials: true,
	// `headers`选项是需要被发送的自定义请求头信息
	headers: {
		// 'Content-Type': 'application/x-www-form-urlencoded'
		'Content-Type': 'application/json',
		applicationId: process.env.VUE_APP_ID, // 超用团标识 做部分埋点 java 需要识别
	},
};

/**
 * 获取系统参数
 *
 */
const getSysParams = () => {
	const ts = DateUtil.parseIntSeconds(+new Date()) / 1000;
	let di = CookiesTools.getDi();
	let si = md5(di + new Date().getTime() + Math.random().toString(36).substring(2, 15));
	si = si.slice(0, 4) + si.slice(si.length - 4, si.length);

	return {
		ct: 'pc',
		ts: ts,
		si, //不能为空，默认12345678
		di,
		nt: 'wifi',
		vn: '1.0',
		im: '',
	};
};
/**
 * 生成签名
 * @sysParams 系统参数
 * @businessParams 业务参数
 */
const getSign = (sysParams = {}, businessParams = {}) => {
	let params = {
		...sysParams,
		...businessParams,
	};
	let keys = Object.keys(params).sort();
	let str = keys.reduce((prev, next) => {
		return `${prev}${next}${params[next]}`;
	}, '');
	let signStr = `${str}${API_SECRET}`;
	return md5(signStr);
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
	function (config) {
		let sysParams = getSysParams();
		let sg;
		if (config.method.toLowerCase() === 'get') {
			sg = getSign(sysParams, config.params);
			config.params = {
				sg,
				...sysParams,
				...config.params,
			};
		} else {
			sg = getSign(sysParams, config.data);
			config.params = {
				sg,
				...sysParams,
			};
		}

		const cookie = CookiesTools.getToken();

		// 校验是否在其他窗口切换登录了其他账号
		checkAccount(cookie, config);
		// 将cookie中的值放到header头中
		config.headers['Custom-Cookie'] = createCustomCookie();
		config.headers['authorization'] = `Bearer ${CookiesTools.getToken()}`;
		config.headers['data-view-id'] = store.state.vuex_dataViewId;
		config.headers['tenant-id'] = store.state.vuex_tenantId || '0';
		// 部分接口 增加埋点
		let split_url = config.url.split('?')[0] || '';
		config.headers['burial-point'] = API_OBJECT[split_url.toString()] || 0;
		return config;
	},
	function (error) {
		// Do something with request error
		return Promise.reject(error);
	},
);

// 返回拦截器
_axios.interceptors.response.use(
	function (response) {
		// Do something
		return response;
	},
	function (error) {
		if (error.message.includes('timeout')) {
			// 超时
			error.code = ERROBJ.timeout.code;
			error.message = '请求超时，请检查网络后重试';
			return Promise.reject(error);
		}
		return Promise.reject(error);
	},
);
// 根据分割uri字符串检测是否是易接口
const checkIsYiiApi = url => {
	let _fisrt = '';
	const [first, second] = url.split('/');
	_fisrt = first || second;
	return ['api', 'seller', 'wechat', 'common', 'upload', 'partner', 'anchor'].includes(_fisrt);
};

const getBaseUrl = _param => {
	// 参数mock为true走yapi mock
	const isYii = checkIsYiiApi(_param.url);
	return process.env.NODE_ENV === 'development'
		? _param.mock
			? '/mock'
			: isYii
			? '/baseapi'
			: '/javaapi'
		: isYii
		? apiBaseUrl(false)
		: apiBaseUrl(true);
};

// 消息限制 同样的消息只展示一次
let msgLimitMap = {};

const request = async _param => {
	try {
		if (!_param.method) {
			_param.method = AjaxMethod.post;
		}
		try {
			await HotFresh.handleHotFresh(_param.url, location.pathname);
		} catch (error) {
			console.error('热更新失败', error);
		}

		// 走yapi mock
		_axios.defaults.baseURL = getBaseUrl(_param);
		const response = await _axios(_param);
		const { status, data } = response;
		if (status !== 200) return Promise.reject(response);
		// 检查是否有接口参数变更导致的错误，是否需要热更新
		if (data.code == 4000) {
			try {
				await HotFresh.handleHotFresh(response?.config?.url, location.pathname, true);
			} catch (error) {
				console.error('热更新失败', error);
			}
		}
		// 登陆失效
		if (data.code === 2000001 || data.code === 1600002) {
			utils.clearData();
			resetCookie('');
			if (location.pathname !== '/login') {
				location.replace('/login');
			}
			return data;
		} else if (data.code === 2002) {
			// 数据库链接中断
			store.commit(types.ALERT_MSG, true);
			return data;
		}
		if (data.extra_data) {
			const open_activity = data.extra_data?.open_activity;
			const need_alert = open_activity?.need_alert;
			const rights = open_activity?.rights
				?.map(item => {
					return Number(item);
				})
				.filter(item => item);
			if (open_activity && rights?.length && need_alert == 1) {
				Vue.$showActivityModel({
					rightTypes: rights,
				});
			}
		}
		if (data.code !== 0 && data.code !== 2010002) {
			// 只有当前消息未展示过的情况下才展示
			if (!msgLimitMap[data.message]) {
				msgLimitMap[data.message] = true;
				Vue.prototype.$message.error({
					message: data.message,
					onClose: () => {
						// 关闭后重置
						msgLimitMap[data.message] = false;
					},
				});
			}
			return _param.notOrigin ? Promise.reject({ code: data.code, message: data.message }) : data;
		}
		if (setCookieUrl.includes(_param.url) && data.data.accessToken) {
			resetCookie(data.data.accessToken);
		}
		if (_param.url == '/api/account/logout') {
			resetCookie('');
		}
		return _param.notOrigin ? data.data : data;
	} catch (err) {
		return Promise.reject({
			code: -1,
			message: err.message,
		});
	}
};

// 尝试重复请求
export const requestTry = async (callback, n) => {
	let errArr = [];
	for (let i = 0; Number(i) < Number(n); i++) {
		try {
			return await callback();
		} catch (err) {
			errArr.push(err);
		}
	}
	return Promise.reject(errArr);
};

export default request;
